var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14.769,
    viewBox: "0 0 16 14.769",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/location"
  }, /*#__PURE__*/React.createElement("g", {
    id: "location"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8 8.265a1.92 1.92 0 1 0 0 -3.84 1.92 1.92 0 0 0 0 3.84Z",
    stroke: "#1D2023",
    strokeWidth: 1.476923076923077
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.843 5.225c1.214 -5.329 9.108 -5.323 10.314 0.006 0.709 3.126 -1.236 5.772 -2.942 7.409a3.196 3.196 0 0 1 -4.436 0c-1.698 -1.637 -3.643 -4.289 -2.935 -7.415Z",
    stroke: "#1D2023",
    strokeWidth: 1.476923076923077
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.62efb22298f1df64dd838748826fda63.svg";
export { ForwardRef as ReactComponent };